import React from 'react';
import { forwardRef, Text } from '@chakra-ui/react';

const NoWrap = forwardRef((props, ref) => (
  <Text as="span" ref={ref} {...props} whiteSpace="nowrap" />
));

export default NoWrap;
